import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import fr from './locales/fr.json'
import en from './locales/en.json'

const resources = {
  fr: { translation: fr },
  en: { translation: en },
}

// Keep the document <html lang> in sync with the active language so that
// components reading document.documentElement.lang (e.g. SignaturePad,
// DocumentParaphFlow) and SEO/a11y tooling see the correct locale.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined' && document.documentElement && lng) {
    document.documentElement.lang = lng.split('-')[0]
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })
  .then(() => syncHtmlLang(i18n.language))

// Set it once immediately (in case init resolves later) and on every switch.
syncHtmlLang(i18n.language)
i18n.on('languageChanged', syncHtmlLang)

export default i18n
